import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { COMPASS_STEPS } from '@/components/flows/CompassFlow/constants'
import CompanyCompassLink from '@/components/layouts/DashboardLayout/CompanyDashboardCompassLayout/components/CompassPageHeader/CompanyCompassLink'
import ActionLink from '@/components/misc/ActionLink'
import PageHeader from '@/components/misc/PageHeader'
import { Button } from '@/components/ui/button'
import useAppDispatch from '@/hooks/useAppDispatch'
import { faPlus } from '@/lib/fontAwesomePro/solid'
import { ROUTES } from '@/lib/routes'
import { resetCompass, startCompass } from '@/redux/slices/compass'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>

const CompassPageHeader: React.FC<Props> = () => {
  const dispatch = useAppDispatch()

  return (
    <header className="mb-4">
      <PageHeader
        title="Compass"
        className="mb-4"
        tabs={[
          { label: 'Dashboard', to: ROUTES.companyCompassDashboard() },
          { label: 'Snapshots', to: ROUTES.companyCompassSnapshots() },
          { label: 'Admin', to: ROUTES.companyCompassAdmin() },
          { label: 'Global link', to: ROUTES.companyCompassGlobalLink() },
          {
            label: 'Invite clients',
            to: ROUTES.companyCompass({
              searchParams: { step: COMPASS_STEPS.inviteClients },
            }),
            beforeNavigate: () => {
              dispatch(startCompass(COMPASS_STEPS.inviteClients))
            },
          },
        ]}
      />

      <div className="flex flex-wrap items-center justify-between gap-4">
        <Button
          variant="primary"
          className="w-full sm:w-auto"
          size="lg"
          asChild
        >
          <ActionLink
            beforeNavigate={() => dispatch(resetCompass())}
            to={ROUTES.companyCompass()}
          >
            <FontAwesomeIcon icon={faPlus} style={{ fontSize: '16px' }} />
            Start Compass
          </ActionLink>
        </Button>
        <CompanyCompassLink />
      </div>
    </header>
  )
}

export default CompassPageHeader
